import useApi, { ApiOptions } from '../base/useApi';
interface Params {
  userId: string;
}

interface Result {
  activationCode: string;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/user/resend_activation_code',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useResendActivationCode = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useResendActivationCodeLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useResendActivationCode;
